/**=========================================================
 * Module: analysis.js
 * Analysis Controller
 =========================================================*/

App.controller('AnalysisController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog',
    function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog) {
      "use strict";

      $scope.type = 'analysis';
      $scope.id = $state.params.filter;

      $scope.model = {};
      $scope.error = {};

      $scope.page = {
        title: 'labels.EDITANALYSIS',
        subTitle: ''
      }

      $scope.pop = function (type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
      };

      function getForm($scope, isPre){
        return {
          title: '',
          status: '',
          type: 'analysis',
          model: $scope.model,
          fields: [{
              available: true,
              type: 'alert',
              alertCls: 'info',
              noLabel: true,
              inputColumn: 12,
              message: 'labels.EDITANALYSISINFO'
            },
            {
              available: true,
              type: 'switch',
              name: 'mode',
              label: 'labels.EDITANALYSISMODE',
              required: true,
              options: [{
                value: 'replaceValues',
                label: 'labels.EDITANALYSISREPLACE'
              }, {
                value: 'addValues',
                label: 'labels.EDITANALYSISADD'
              }]
            }, {
              available: true,
              type: 'file',
              name: (isPre ? 'pre' : '') + 'uploadModifyValues',
              canUpload: true,
              label: 'fields.UPLOAD',
              inputColumn: 12,
              limit: 1,
              allow: 'csv',
              bucket: $rootScope.bucketName($scope.model.client)
            }, {
              available: true,
              type: 'number',
              label: 'labels.CONTEXTMATCH',
              name: 'conM'
            }, {
              available: true,
              type: 'number',
              label: 'labels.FULLMATCH',
              name: 'fulM'
            }, {
              available: true,
              type: 'number',
              label: 'labels.FUZZYMATCH',
              name: 'fuzM'
            }, {
              available: true,
              type: 'number',
              label: 'labels.NOMATCH',
              name: 'noMT'
            }, {
              available: _.contains($scope.project.dtpTypes, 'GRAPHICTEXT'),
              type: 'number',
              label: 'fields.NOMATCHG',
              name: 'noMG'
            }, {
              available: true,
              type: 'submit',
              name: 'empty',
              label: 'labels.EDIT',
              labelColumn: 0
            }
          ],
          errorLabel: 'labels.ERROR',
          validate: function () {
            var errors = [];
            for (var i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];
              if (field.required && !this.model[field.name]) {
                errors.push({
                  field: field,
                  error: 'required'
                });
              }

            }
            if (errors.length) {
              var errorMessages = "<ul>";
              for (var i = 0; i < errors.length; i++) {
                var e = errors[i];
                errorMessages += "<li>" +
                  $filter('translate')('labels.VALIDATIONERROR' + e.error.toUpperCase(), {
                    name: $filter('translate')(e.field.label || ('fields.' + e.field.name.toUpperCase()))
                  }) +
                  "</li>";
              }
              errorMessages += "</ul>";
              $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
              return false;
            } else return true;
          },
          submit: function () {
            var self = this;
            if (this.validate()) {
              $scope.confirmLabel = 'CONFIRMEDITANALYSIS';
              ngDialog.openConfirm({
                template: '/app/views/entities/confirm-withlabel.html',
                className: 'ngdialog-theme-default',
                scope: $scope
              }).then(function (value) {
                
                  self.status = 'submitting';
                  var id = self.model.source + '_' + self.model.destination;
                  self.model.action = 'ModifyValues';
                  if(isPre) self.model.isPre = true;
                  D.save('analysis', self.model).then(
                    function (response) {
                      $scope.analysisForm.status = 'submitted';
                      load();


                    }
                    
                  ).catch(function (response) {
                      $scope.analysisForm.status = 'error';
                      if(response.data.msg.indexOf('normTotal=')===0){
                        $scope.analysisForm.errorLabel = 'labels.ERRORNORMTOTALNEGATIVE';
                      }
                      if(response.data.msg.indexOf('recovered=')===0){
                        $scope.analysisForm.errorLabel = 'labels.ERRORRECOVEREDNEGATIVE';
                      }
                    });
                
              });
            }
          }
        }
      }

      function load(){
        D.load($scope.type, $scope.id, { cache: false }).then(
          function (model) {
            $scope.model = model;
            $scope.model.preAnalysis = $scope.model.preAnalysis || '{}';
            D.load('project', $scope.model.project, { cache: false }).then(
              function (data) {
                $scope.project = data;
                $scope.page.subTitle = data.code;

                $scope.analysisForm = getForm($scope, false);
                $scope.preAnalysisForm = getForm($scope, true);

              }
            ).catch(console.error)
          }
          
        ).catch(function (error) {
            $scope.error = error;
          });
      }
      load();





    }
  ]);